export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '3c073cc', dateTime: 1774542004723 };